var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$abilities.includes('update shipments'))?_c('v-btn',{attrs:{"color":"primary","small":"","disabled":!_vm.$route.query.batch},on:{"click":_vm.cancelBatch}},[_vm._v(" Close batch "),_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v(" mdi-collapse-all ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }